module.exports = __webpack_public_path__ + "static/img/D3000.dd0ed05.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/device/D3000/D3000.png
// module id = zAeY
// module chunks = 0